<template>
  <BgImageLayout title="Reports" :page="__guide.reports" icon-color="white">
    <template #after-title>
      <StartReportBtn class="q-ml-sm" />
    </template>

    <q-card class="reports-wrapper fit no-padding">
      <q-card-section class="reports no-padding">
        <router-view :key="$route.fullPath" />
        <ToolPanel />
      </q-card-section>
    </q-card>
  </BgImageLayout>
</template>

<script>
// Components
import ToolPanel from './components/tool-panel/ToolPanel'
import StartReportBtn from './components/StartReportBtn'

export default {
  components: {
    ToolPanel,
    StartReportBtn
  },

  beforeDestroy() {
    this.$store.unregisterModule('reports')
  }
}
</script>

<style lang="stylus" scoped>
>>> .bg-img-layout--page-content {
  overflow hidden
}

.reports {
  width 100%
  height 100%
  display grid
  grid-template-columns 1fr 300px

  .content {
    display grid
    grid-template-rows 50px 1fr
  }
}
</style>
